import { environment } from "../environment";
import { IpAddressResolverService } from "./ipAddressResolverService";

export interface PublicIpResolver {
  resolveClientIpAddress(): Promise<string>;
}

/**
 * Supplies a public-IP hint only for local development, where the auth service
 * otherwise observes the loopback address. The auth service validates the
 * value and ignores this header outside its development profile.
 */
export class AuthLocationHintService {
  constructor(
    private readonly ipResolver: PublicIpResolver = new IpAddressResolverService(),
    private readonly enabled = environment.authClientIpHintEnabled,
  ) {}

  async headers(): Promise<Record<string, string>> {
    if (!this.enabled) return {};

    try {
      const ipAddress = (await this.ipResolver.resolveClientIpAddress()).trim();
      return ipAddress ? { "X-JobsRmine-Client-IP": ipAddress } : {};
    } catch (error: unknown) {
      console.warn("Could not resolve the development client-IP hint", error);
      return {};
    }
  }
}
